export default __webpack_public_path__ + "static/media/logo_salesforce.565507c3.svg";